import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { LiveNavigationConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { AdaptiveLayoutState, ColumnLayoutService } from '@frontend/sports/layout/feature';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { DetailedEventViewModel } from '../event-details-common/event-details-common.models';
import { LiveSubnavTabs, createSubnavTabs } from '../event-list/navigation/live-subnavigation.models';
import { SportSubNavigationService } from '../sub-navigation/sport-sub-navigation/sport-sub-navigation.service';
import { SubNavigationResolve } from '../sub-navigation/sub-navigation-resolve.service';
import { SubNavigationItem } from '../sub-navigation/sub-navigation.models';

@Injectable()
export class EventViewSubNavigationResolve extends SubNavigationResolve<DetailedEventViewModel> {
    constructor(
        private layoutManager: ColumnLayoutService,
        private liveNavConfig: LiveNavigationConfig,
        private sitecore: Sitecore,
        private urlHelperService: UrlHelperService,
        private sportSubNavService: SportSubNavigationService,
    ) {
        super();
        this.tabs$.next(this.getDefaultTabs());
    }

    buildSubNavigation(layout: AdaptiveLayoutState, routeSnapshot: ActivatedRouteSnapshot, model: DetailedEventViewModel): void {
        if (
            !this.liveNavConfig.isLiveEventsNavigationEnabled ||
            this.layoutManager.layout.maxColumnCount < 3 ||
            !this.isDetailedEventViewModel(model)
        ) {
            this.tabs$.next([]);

            return;
        }

        if (!model.model!.live || this.isPrematchLeftNavigationOpened()) {
            this.sportSubNavService.resolveTabs(layout, routeSnapshot, model.model!.sport.id).subscribe((items) => this.tabs$.next(items));

            return;
        }

        this.tabs$.next(this.getDefaultTabs());
    }

    private getDefaultTabs(): SubNavigationItem[] {
        return createSubnavTabs(this.urlHelperService, this.sitecore, LiveSubnavTabs.EventView);
    }

    private isDetailedEventViewModel(model: DetailedEventViewModel): model is DetailedEventViewModel {
        if (model.model) {
            return true;
        }

        return false;
    }

    private isPrematchLeftNavigationOpened(): boolean {
        return this.layoutManager.layout.registeredComponents().some((c) => c.component.name === 'PrematchEventsNavigationComponent');
    }
}
